











































































































































































































































import { Component, Mixins, Prop, Emit, Ref } from "vue-property-decorator";
import { cantMoving, runPrecheckLeaveAlertIfNeeded } from "@/main";
import { Menu } from "@/types";
import { SideMenu } from "@/components/app/types";
import UtilMixin from "@/mixins/utilMixin";
import AxiosMixin from "@/mixins/axiosMixin";
import DateMixin from "#/mixins/dateMixin";
import PrecheckAlertMixin from "@/mixins/precheckAlertMixin";
import ChikenLauncher from "../home/chikenLauncher.vue";
import OfficeSelect from "../home/OfficeSelect.vue";
import PrecheckLeaveAlertDialog from "@/components/receipt/PrecheckLeaveAlertDialog.vue";
import Cookies from "js-cookie";
import { AxiosResponse } from "axios";

@Component({
  components: { ChikenLauncher, OfficeSelect, PrecheckLeaveAlertDialog }
})
export default class AppMenu extends Mixins(
  UtilMixin,
  AxiosMixin,
  DateMixin,
  PrecheckAlertMixin
) {
  @Prop() sideMenu!: SideMenu;

  @Ref("chikenLauncher") private readonly chikenLauncher!: ChikenLauncher;

  @Ref("officeSelect") private readonly officeSelect!: OfficeSelect;

  @Ref("precheckLeaveAlertDialog")
  private readonly precheckLeaveAlertDialog!: PrecheckLeaveAlertDialog;

  private get AppVersion() {
    return window.app_version;
  }

  private get officeName() {
    return this.masters.offices.find(
      office => office.value === this.loginUser.office_id
    )?.text;
  }

  // URLのパス部のスラッシュ有無を統一
  private get url() {
    return (url: string) => {
      // 先頭スラッシュは付ける
      url = url[0] === "/" ? url : "/" + url;
      // ホーム画面でない限り末尾スラッシュは付けない
      url = url.slice(-1) === "/" && url !== "/" ? url.slice(0, -1) : url;
      return url;
    };
  }

  // 遷移しようとするURLは現在のと同じまたは子孫階層か
  private get isUrlSameChild() {
    return (urlTo: string) => {
      const urlSlashCount = this.url(urlTo).match(/\//g)?.length ?? 0;
      // ルートの子階層URLが遷移先であれば、子孫にもマッチする
      if (urlSlashCount === 1 && urlTo.length !== 1) {
        return this.$route.path.startsWith(this.url(urlTo));
      }
      return this.url(urlTo) === this.$route.path;
    };
  }

  private async linkto(menu: Menu) {
    if (menu.id == 171) {
      //旧iBowレセプトの場合
      //ワンタイムトークン
      let oneTimeToken = "";
      this.postJsonCheck(
        window.base_url + "/api/receipt/v1onetimetoken",
        {},
        res => {
          oneTimeToken = res.data.one_time_token;
          const url = menu.url + "/?onetime=" + oneTimeToken;
          window.open(url, "_blank");
        }
      );
    } else if (menu.id == 22) {
      //iBow治験の場合
      this.chikenLauncher.launch(menu.url);
    } else {
      // 同じページには遷移しない
      if (this.url(menu.url) === this.$route.path) {
        return;
      }
      if (menu.is_outer == 1) {
        // iBowレセプト(id=17)・iBowボード配下(id=110〜116)をレセプト処理・利用者レセプト画面から開く場合はアラートBを挟む
        if (
          (menu.id == 17 || (menu.id >= 110 && menu.id <= 116)) &&
          this.isOnReceiptScreen() &&
          !(await this.confirmOpenIbowReceipt())
        ) {
          return;
        }
        window.open(menu.url, "_blank");
      } else if (menu.is_outer == 2) {
        location.href = menu.url;
      } else if (menu.is_outer == 3 || menu.is_outer == 4) {
        // AI訪問予定・ルート(id=26)をレセプト処理・利用者レセプト画面から開く場合はアラートBを挟む
        if (
          menu.id == 26 &&
          this.isOnReceiptScreen() &&
          !(await this.confirmOpenIbowReceipt())
        ) {
          return;
        }
        this.officeSelect.launch(
          menu.url,
          menu.get_office_list_url,
          menu.is_outer == 4
        );
      } else if (menu.is_outer == 101) {
        //けあログっとを開く
        // レセプト処理・利用者レセプト画面から開く場合はアラートBを挟む
        if (
          this.isOnReceiptScreen() &&
          !(await this.confirmOpenIbowReceipt())
        ) {
          return;
        }
        this.postJsonCheck(
          window.auth_backend_url + "/outer/auth/portal/token",
          {
            portal_office_staff_id: this.loginUser.portal_staff_id,
            portal_office_staff_role: this.loginUser.portal_staff_role,
            portal_office_id: this.loginUser.portal_office_id
          },
          res => {
            this.setCookie(res);
            location.href = menu.url;
          }
        );
      } else if (menu.is_outer == 102) {
        //カエドキを開く
        this.postJsonCheck(
          window.auth_backend_url + "/outer/auth/jobsearch/token",
          {
            jobsearch_recruiter_id: this.loginUser.kaedoki_staff_id,
            jobsearch_recruiter_role: this.loginUser.kaedoki_staff_role,
            portal_office_id: this.loginUser.kaedoki_office_id
          },
          res => {
            this.setCookie(res);
            location.href = menu.url;
          }
        );
      } else {
        this.$router.push(menu.url);
      }
    }
  }

  /** iBowレセプト起動前のアラートB確認。 */
  private async confirmOpenIbowReceipt(): Promise<boolean> {
    try {
      if (await this.isPrecheckAlertSuppressedToday()) return true;
      const result = await this.precheckLeaveAlertDialog.open();
      if (result.suppressToday) {
        await this.savePrecheckAlertSuppress();
      }
      return result.ok;
    } catch {
      // 万一アラート処理が失敗してもメニュー遷移は通す
      return true;
    }
  }

  /** レセプト処理・利用者レセプト画面に滞在中か */
  private isOnReceiptScreen(): boolean {
    return (
      this.$route.path === "/reciept" || this.$route.path === "/reciept-patient"
    );
  }

  //ログアウト
  private async logout() {
    if (!(await runPrecheckLeaveAlertIfNeeded())) {
      return;
    }
    if (!(await this.$openConfirm("ログアウトしますか？"))) {
      return;
    }
    this.toLogout();
  }

  //ログアウト
  @Emit()
  private toLogout() {
    return;
  }

  //マイページへ
  private async toMypage() {
    // 編集を破棄したくない場合は処理しない
    if (await cantMoving()) {
      return;
    }
    if (!(await runPrecheckLeaveAlertIfNeeded())) {
      return;
    }
    location.href = window.auth_frontend_url;
  }

  //サイドメニューの縮小を解除
  private sideExpand() {
    if (this.sideMenu.isNarrow) {
      this.toggleSideNarrow();
    }
  }

  @Emit()
  private toggleSideOpen() {
    return;
  }

  //サイドメニューを狭くする(PC幅)
  @Emit()
  private toggleSideNarrow() {
    return;
  }

  /** クッキーに設定 */
  private setCookie(res: AxiosResponse) {
    window.token = res.data.token;
    Cookies.set("token", res.data.token, {
      domain: window.cookie_domain
    });
    window.reftoken = res.data.ref_token;
    Cookies.set("reftoken", res.data.ref_token, {
      domain: window.cookie_domain
    });
  }
}
